import {
  checkIsElementIsVmlTag,
  getTag,
  isElementPureText,
  prettifyHtml
} from '@fmpedia/html-tools'

export { prettifyHtml, getTag, isElementPureText, checkIsElementIsVmlTag }
